export default __webpack_public_path__ + "static/media/tom.d1bd7f70.jpg";